import {Component, OnInit, inject, input, signal, output} from '@angular/core';
import {FormGroup, FormControl} from '@angular/forms';
import {StatutsTrajet, StatutsTrajetPourGestionNavette} from '../../model/statut-trajet.enum';
import {TranslateService} from '@ngx-translate/core';
import {filtrageTrajetValidation} from '../../validateurs/trajet.validateurs';
import {SelectItem} from 'primeng/api';
import {FormulaireFiltrageTrajets} from '../../model/formulaire-filtrage-trajets';

@Component({
	selector: 'app-filtrage-trajets',
	templateUrl: './filtrage-trajets.component.html',
	styleUrl: './filtrage-trajets.component.scss'
})
export class FiltrageTrajetsComponent implements OnInit {
	// Injections
	private translateService = inject(TranslateService);

	// Inputs
	estBoutonFiltreDesactive = input<boolean>(false);
	suggestionsLieux = input.required<string[]>();

	// Outputs
	filtresAppliques = output<FormulaireFiltrageTrajets>();
	filtresReinitialises = output<void>();

	// Signaux
	filtresActifs = signal(false);
	statutsTrajet = signal<SelectItem[]>([]);
	suggestionsFormatees = signal<string[]>([]);

	// Variables
	filtresForm: FormGroup;
	sectionFiltrageOuverte = false;

	constructor() {
	}

	ngOnInit() {
		this.filtresForm = new FormGroup({
			afficherTrajetsPasses: new FormControl(false),
			statutsTrajet: new FormControl([], { nonNullable: true }),
			lieuxDepart: new FormControl([], { nonNullable: true }),
			lieuxArrivee: new FormControl([], { nonNullable: true }),
			heureDepart: new FormControl(null),
			heureArrivee: new FormControl(null),
			maximumPlaces: new FormControl(null),
			minimumPlaces: new FormControl(null)
		}, { validators: filtrageTrajetValidation() });

		this.initialiseStatutsTrajet();
		this.verifierFiltresActifs();
	}

	/**
	 * Initialise la liste des statuts pour le filtrage avec le multiselect.
	 */
	private initialiseStatutsTrajet(): void {
		const keys = Object.values(StatutsTrajetPourGestionNavette).map(statut => StatutsTrajet.get(statut).cleTraduction);
		this.translateService.stream(keys).subscribe(translations => {
			this.statutsTrajet.set(
				Object.values(StatutsTrajetPourGestionNavette).map(statut => ({
					label: translations[StatutsTrajet.get(statut).cleTraduction],
					value: statut
				}))
			);
		});
	}

	/**
	 * Méthode appelée lors du ngOnInit pour qu'à chaque changement de formulaire, on vérifie si des filtres sont désormais actifs.
	 */
	verifierFiltresActifs(): void {
		this.filtresForm.valueChanges.subscribe((formActuel) => {
			const formActuelObj = new FormulaireFiltrageTrajets(
				formActuel.afficherTrajetsPasses,
				formActuel.statutsTrajet,
				formActuel.lieuxDepart ?? [],
				formActuel.lieuxArrivee ?? [],
				formActuel.heureDepart,
				formActuel.heureArrivee,
				formActuel.maximumPlaces,
				formActuel.minimumPlaces
			);
			this.filtresActifs.set(formActuelObj.sontFiltresActifs());
		});
	}

	/**
	 * Ouvre le menu de filtrage.
	 */
	ouvrirFiltres(): void {
		this.sectionFiltrageOuverte = true;
	}

	/**
	 * Émet les valeurs du formulaire si ce dernier est valide et ferme le menu de filtrage.
	 */
	appliquerFiltres(): void {
		if (this.filtresForm.valid) {
			this.filtresAppliques.emit(this.filtresForm.value);
			this.sectionFiltrageOuverte = false;
		}
	}

	/**
	 * Réinitialise le filtre de statuts de trajet avec un tableau vide.
	 */
	reinitialiserFiltreStatut(): void {
		this.filtresForm.get('statutsTrajet')?.setValue([]);
	}

	/**
	 * Réinitialise le formulaire de filtrage à ses valeurs par défaut.
	 */
	reinitialiserFiltres(): void {
		this.filtresForm.reset(new FormulaireFiltrageTrajets());
		this.filtresReinitialises.emit();
	}

	/**
	 * Filtre les suggestions de lieux en fonction de la saisie de l'utilisateur.
	 *
	 * @param event l'événement de saisie contenant la requête de recherche.
	 */
	completeMethodLieu(event: { query: string }): void {
		const query = event.query;

		this.suggestionsFormatees.set(
			this.suggestionsLieux().filter(item => item.toLowerCase().includes(query.toLowerCase()))
		);
	}
}